/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/pagebuttons/pagebuttons_styles';



/* ========== ~~~~~~~~~~ IMAGE API : PAGE BUTTONS ~~~~~~~~~~ ========== */
const PageButtons = (props) => {
    return (
        <div className={`${props.classes.pagebuttons} pagebuttons`} >
    		{props.pages && <Button type={`custom`} handleClick={(e) => props.pagination(true)} variant={`system`} name={`next`} text={`Next`} icon={`arrow-right`} iconRight />}
            {props.page > 1 && <Button type={`custom`} handleClick={(e) => props.pagination(false)} variant={`system`} name={`previous`} text={`Previous`} icon={`arrow-left`} />}
        </div>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PageButtons);
